import { AppRouteProps } from "@harea/component";
import React from "react";
import { PayrollListRoutes } from "./views/processing/PayrollListRoutes";
import { PayrollSettingsRoutes } from "./views/settings/PayrollSettingsRoutes";
import { DeclarationRoutes } from "./views/declarations/DeclarationRoutes";
import { PrimeRoutes } from "./views/primes/PrimeRoutes";
import { IndemnityRoutes } from "./views/indemnities/IndemnityRoutes";
import { PaybackRoutes } from "./views/paybacks/PaybackRoutes";
import { AvanceListRoutes } from "./views/avance/AvanceListRoutes";

import { LoanRoutes } from "./views/loan/LoanRoutes";
import { CotisationSyndicaleRoutes } from "./views/cotisation-syndicale/CotisationSyndicaleRoutes";

const PayrollContainer = React.lazy(() => import("container/PayrollContainer"));

export const PayrollRoutes = [
    {
        path: "payrolls",
        element: <PayrollContainer />,
        title: "BSMRH.Payroll.Title",
        roles: ["PAYROLL_PROCESS"],
        children: [
            ...PayrollListRoutes,
            ...PayrollSettingsRoutes,
        ]
    },
    ...AvanceListRoutes,
    ...LoanRoutes,
    ...DeclarationRoutes,
    ...PrimeRoutes,
    ...IndemnityRoutes,
    ...PaybackRoutes,
    ...CotisationSyndicaleRoutes,

] as Array<AppRouteProps>;
